import { TextField } from "@mui/material";
import React, { forwardRef } from "react";

const InputField = forwardRef(function InputField(
  { variant, error, label, size="medium", ...props },
  ref
) {
  return (
    <div className="w-full">
      <TextField
        className="w-full"
        variant={variant}
        label={label}
        color={error !== undefined ? "error" : "primary"}
        {...props}
        ref={ref}
        size={size}
      />
      {error && <p className="mt-2 text-red-500 text-[16px]">*{error?.message}</p>}
    </div>
  );
});

export default InputField;
